/**
 * Liste des dossiers de traduction chargés au démarrage (assets/i18n/<namespace>/{fr,en}.json),
 * fusionnés par le TranslateMultiHttpLoader (voir app.config.ts). Un namespace manquant ou
 * incomplet ne casse rien : une ressource en échec est remplacée par un objet vide (voir
 * TranslateHttpLoaderConfig.failOnError, false par défaut).
 *
 * Ajouter une nouvelle page traduite = ajouter son namespace ici + créer
 * assets/i18n/<namespace>/fr.json et en.json.
 */
export const I18N_NAMESPACES: string[] = [
  'common',
  'shell',
  'auth',
  'components',
  'components-wizard',
  'etablissement',
  'horaires-informations',
  'gestion-equipes',
  'equipements',
  'site',
  'accueil',
  'previsions',
  'qualite',
  'satisfaction',
  'actualite',
  'pilotage',
  'pilotage-prevention',
  'prevention-offres',
  'comm-prevention',
  'profile-ia',
  'formulaire',
  'rapport',
  'support',
  'mobile-simulator',
];
